import { render, staticRenderFns } from "./wdscList.vue?vue&type=template&id=d8b442d2&scoped=true&"
import script from "./wdscList.vue?vue&type=script&lang=js&"
export * from "./wdscList.vue?vue&type=script&lang=js&"
import style0 from "./wdscList.vue?vue&type=style&index=0&id=d8b442d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b442d2",
  null
  
)

export default component.exports